export default "__VITE_ASSET__2ub6ZI8G__"